var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"listen-network-player"},[(_vm.urlDataLoaded)?_c('player',{attrs:{"podcast-name":_vm.podcastName,"episode-name":_vm.episodeName,"episode-description":_vm.episodeDescription,"episode-audio":_vm.episodeAudio,"accent-color":_vm.accentColor}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }